import { render, staticRenderFns } from "./FieldsetPasswordChangeParts.vue?vue&type=template&id=007fbf5b&scoped=true"
import script from "./FieldsetPasswordChangeParts.vue?vue&type=script&lang=ts"
export * from "./FieldsetPasswordChangeParts.vue?vue&type=script&lang=ts"
import style0 from "./FieldsetPasswordChangeParts.vue?vue&type=style&index=0&id=007fbf5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007fbf5b",
  null
  
)

export default component.exports